if (!window.Eurus) window.Eurus = { loadedScript: new Set() };
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('subscription-builder.js')) {
  window.Eurus.loadedScript.add('subscription-builder.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xSubscriptionBuilder', (config) => ({
        sectionId: config.sectionId,
        currencyFormat: config.currencyFormat,
        planGroupIndex: config.planGroupIndex || 0,
        planIndex: config.defaultPlanIndex != null ? config.defaultPlanIndex : 0,
        selected: {},
        products: {},
        loading: false,
        errorMessage: '',

        bootBuilder(rootEl) {
          const cards = rootEl.querySelectorAll('script[data-sb-product]');
          cards.forEach((scriptEl) => {
            const blockId = scriptEl.getAttribute('data-sb-product');
            try {
              this.products[blockId] = JSON.parse(scriptEl.textContent);
              this.selected[blockId] = false;
            } catch (e) {
              console.warn('[subscription-builder] failed to parse product block', blockId, e, scriptEl.textContent);
            }
          });
          const planCount = this.firstProductPlanCount();
          if (planCount && this.planIndex >= planCount) {
            this.planIndex = planCount - 1;
          }
        },

        firstProductPlanCount() {
          const ids = Object.keys(this.products);
          if (!ids.length) return 0;
          return (this.products[ids[0]].plans || []).length;
        },

        get selectedBlockIds() {
          return Object.keys(this.selected).filter((id) => this.selected[id]);
        },

        get hasSelection() {
          return this.selectedBlockIds.length > 0;
        },

        packSizeFor(plan) {
          if (!plan) return 1;
          const ic = parseInt(plan.intervalCount, 10);
          if (plan.interval === 'month' && ic > 0) return ic;
          const m = (plan.name || '').match(/(\d+)/);
          if (m) return parseInt(m[1], 10);
          return ic > 0 ? ic : 1;
        },

        get originalTotal() {
          return this.selectedBlockIds.reduce((sum, id) => {
            const p = this.products[id];
            if (!p) return sum;
            const plan = (p.plans || [])[this.planIndex];
            const qty = this.packSizeFor(plan);
            return sum + p.basePrice * qty;
          }, 0);
        },

        get orderTotal() {
          return this.selectedBlockIds.reduce((sum, id) => {
            const p = this.products[id];
            if (!p) return sum;
            const plan = (p.plans || [])[this.planIndex];
            const qty = this.packSizeFor(plan);
            if (!plan) return sum + p.basePrice * qty;
            return sum + this.applyPlan(p.basePrice, plan) * qty;
          }, 0);
        },

        get savings() {
          return Math.max(0, this.originalTotal - this.orderTotal);
        },

        applyPlan(basePrice, plan) {
          if (!plan) return basePrice;
          const value = parseFloat(plan.value) || 0;
          if (plan.valueType === 'percentage') {
            return Math.round(basePrice * (100 - value) / 100);
          }
          if (plan.valueType === 'fixed_amount') {
            return Math.max(0, basePrice - Math.round(value));
          }
          if (plan.valueType === 'price') {
            return Math.max(0, Math.round(value));
          }
          return basePrice;
        },

        formatMoney(cents) {
          if (Alpine.store('xHelper') && typeof Alpine.store('xHelper').formatMoney === 'function') {
            return Alpine.store('xHelper').formatMoney(cents, this.currencyFormat);
          }
          try {
            const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
            return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
          } catch (e) {
            return '$' + (cents / 100).toFixed(2);
          }
        },

        async handleAddToCart(el) {
          if (!this.hasSelection || this.loading) return;
          this.errorMessage = '';

          const items = this.selectedBlockIds.map((id) => {
            const p = this.products[id];
            if (!p) return null;
            const plans = p.plans || [];
            if (!plans.length) {
              console.warn('[subscription-builder] product has no plans', p);
              return null;
            }
            const plan = plans[this.planIndex] || plans[plans.length - 1] || plans[0];
            if (!plan || !plan.id) {
              console.warn('[subscription-builder] no plan resolved at index', this.planIndex, p);
              return null;
            }
            const planIdNum = parseInt(plan.id, 10);
            const qty = this.packSizeFor(plan);
            return {
              id: p.id,
              quantity: qty,
              selling_plan: isNaN(planIdNum) ? plan.id : planIdNum
            };
          }).filter(Boolean);

          if (!items.length) {
            this.errorMessage = 'No subscription plan available for the selected products.';
            console.warn('[subscription-builder] no items to add — selectedBlockIds:', this.selectedBlockIds, 'products:', this.products);
            return;
          }

          console.info('[subscription-builder] adding to cart', items);

          this.loading = true;
          const cartHelper = Alpine.store('xCartHelper');
          if (cartHelper && typeof cartHelper.waitForCartUpdate === 'function') {
            try { await cartHelper.waitForCartUpdate(); } catch (e) {}
          }
          window.updatingCart = true;

          try {
            const sectionsToRender = (cartHelper && typeof cartHelper.getSectionsToRender === 'function')
              ? cartHelper.getSectionsToRender().map((s) => s.id)
              : [];
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items, sections: sectionsToRender })
            });
            const data = await response.json();
            console.info('[subscription-builder] cart/add response', response.status, data);

            if (!response.ok || data.status === 422 || data.status === '422') {
              this.errorMessage = data.description || data.message || ('Could not add to cart (HTTP ' + response.status + ').');
              console.error('[subscription-builder] add failed', response.status, data);
              return;
            }

            if (cartHelper && typeof cartHelper.reRenderSections === 'function' && data.sections) {
              cartHelper.reRenderSections(data.sections);
            }
            if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
              Alpine.store('xQuickView').show = false;
            }
            if (Alpine.store('xPopup') && typeof Alpine.store('xPopup').close === 'function') {
              Alpine.store('xPopup').close();
            }
            if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
              Alpine.store('xCartNoti').setItem(data);
            } else if (Alpine.store('xMiniCart') && typeof Alpine.store('xMiniCart').openCart === 'function') {
              Alpine.store('xMiniCart').openCart();
              document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
            }
            if (cartHelper) {
              const bubble = document.getElementById('cart-icon-bubble');
              if (bubble) cartHelper.currentItemCount = parseInt(bubble.innerHTML, 10) || 0;
            }
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            Object.keys(this.selected).forEach((k) => { this.selected[k] = false; });
          } catch (err) {
            console.error('[subscription-builder] add-to-cart threw', err);
            this.errorMessage = 'Could not add to cart: ' + (err && err.message ? err.message : 'unknown error');
          } finally {
            window.updatingCart = false;
            this.loading = false;
          }
        }
      }));
    });
  });
}
